import { app } from '../../../../../app';
import { Controller } from './how-to-add-sms-user.controller';

app.component('companySmsServicesHelpHowToAddSmsUser', {
    controller: Controller,
    templateUrl: require('./how-to-add-sms-user.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/help/how-to-add-sms-user/how-to-add-sms-user.component.js